import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "question",
  "use": "question-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"question\">\n\t<image y=\"-0.5\" width=\"14\" height=\"15\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAQAAAC1QeVaAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiCAoKJBe3OVo7AAAA/ElEQVQY00XQMUtCcRjF4edeLBqC+gAFriI4thlFew0hbaJzyx+bW5wr3qktslanXPwArU1SuIWBc0RIGAQ2dLEzvef8XjhwMiC2JIfKmBiINIUcomUk07BuXUNmFK0CRktX3bldd66tpjN13WiRxZaRenqJPacG9p3YTu9R9aiWxYUsnRFraU6s+LaTnohLi5JDDUhz0PbmGdzrl5SNFYpjXQfF21i5ZKkouXGUXv6T3ESluFdtGC1JxSQ30Pxz6cumzyVsGuRCO6oQax4cFBVVbZGnqY5hVPHj1UeBhjppmhXzXbl1b4yKprZO6hXbpp6ahb6Zmb6FWurBL4ZpUfBcBrfzAAAAAElFTkSuQmCC\"></image>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/question.svg
// module id = mqUg
// module chunks = 264